export default '6.30.2';